import React, { useEffect, useRef, useState } from "react";
import { HorizontalLine, Icon, Text } from "@mbank-design/design-system/components";
import { FontColor, FontSize, FontWeight } from "@mbank-design/design-system/design-tokens/general/typography";
import "./index.scss";
import { ChevronDown } from "@mbank-design/design-system/icons";
import { getSiteRules } from "../../../services";
import rulesCheaper from "../../../assets/files/Taniej-z-mAuto-edycja-4.pdf";
import giftedFuelRules from "../../../assets/files/Regulamin-Paliwo-w-prezencie-dla-klientow-mBanku.pdf";
import moreForLessRules from "../../../assets/files/Regulamin-Wiecej-za-mniej-od-01.04.2026-30.06.2026.pdf";
import extraPremiaRules from "../../../assets/files/Regulamin-promocji-Ekstra-premia-edycja-II-1.pdf";
import { IconColor } from "@mbank-design/design-system/enums";

let columns = [
  {
    name: "mAuto",
    data: [
      {
        name: "o nas",
        link: "/o-nas"
      },
      {
        name: "finansowanie",
        link: "/finansowanie"
      },
      {
        name: "pytania i odpowiedzi",
        link: "/faq"
      },
      {
        name: "regulamin mAuto",
        type: "ruleMAuto"
      },
      {
        name: "polityka prywatności",
        link: "/polityka-prywatnosci"
      },
      {
        name: "ustawienia cookie",
        link: "javascript:mbiscuit.open()"
      }
    ]
  },
  {
    name: "promocje",
    data: [
      {
        name: "regulamin Taniej z mAuto",
        link: rulesCheaper
      },
      {
        name: "regulamin Paliwo w prezencie",
        link: giftedFuelRules
      },
      {
        name: "regulamin Więcej za mniej",
        link: moreForLessRules
      },
      {
        name: "regulamin Ekstra premia",
        link: extraPremiaRules
      }
    ]
  },
  {
    name: "polecane",
    data: [
      {
        name: "samochody nowe",
        link: "/nowe-samochody"
      },
      {
        name: "samochody używane",
        link: "/samochody-poleasingowe"
      },
      {
        name: "samochody elektryczne",
        link: "/samochody-elektryczne"
      }
    ]
  },
  {
    name: "serwisy",
    data: [
      {
        name: "portal klienta",
        link: "https://accounts.mleasing.pl/login"
      },
      {
        name: "mLeasing",
        link: "https://mleasing.pl/"
      },
      {
        name: "blog",
        link: "/blog"
      }
    ]
  }
];

function pdfFileFromBase64(base64Value, fileName) {
  const value = String(base64Value);
  const payload = (value.includes(",") ? value.split(",").pop() : value).replace(/\s/g, "");
  const byteCharacters = atob(payload);
  const byteArray = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }

  const name = fileName && String(fileName).toLowerCase().endsWith(".pdf") ? fileName : "Regulamin_mAuto.pdf";
  return new File([byteArray], name, { type: "application/pdf" });
}

function isIosDevice() {
  const ua = window.navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

const FooterCategoriesLinks = () => {
  const [stateOfColumns, setStateOfColumns] = useState({});
  const rulesFileRef = useRef(null);
  const rulesRequestRef = useRef(null);

  function loadRulesFile() {
    if (!rulesRequestRef.current) {
      rulesRequestRef.current = getSiteRules()
        .then((res) => {
          const file = pdfFileFromBase64(res.data.Base64, res.data.Name);
          rulesFileRef.current = file;
          return file;
        })
        .catch((error) => {
          rulesRequestRef.current = null;
          throw error;
        });
    }

    return rulesRequestRef.current;
  }

  function openRules(event) {
    event.preventDefault();
    const file = rulesFileRef.current;
    if (!file) {
      return;
    }

    if (isIosDevice() && navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator.share({ files: [file] }).catch(() => {});
      return;
    }

    const url = URL.createObjectURL(new Blob([file], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  useEffect(() => {
    const stateOfColumnsObj = {};
    columns.forEach((column) => (stateOfColumnsObj[column.name] = false));

    setStateOfColumns(stateOfColumnsObj);
    loadRulesFile().catch(() => {});
  }, []);

  return (
    <div className="categories-links">
      {columns.map((column, columnIdx) => (
        <React.Fragment key={column && column.name ? column.name : `column-${columnIdx}`}>
          <div className="categories-links__column">
            <div
              className="categories-links__column-header"
              onClick={() => setStateOfColumns({ ...stateOfColumns, [column.name]: !stateOfColumns[column.name] })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setStateOfColumns({ ...stateOfColumns, [column.name]: !stateOfColumns[column.name] });
                }
              }}
            >
              <Text as="p" fontWeight={FontWeight.WEIGHT_600} fontSize={FontSize.SIZE_20}>
                {column.name}
              </Text>
              <div className={"mobile-only centered rotable " + (stateOfColumns[column.name] ? "upside-down" : "")}>
                <Icon iconComponent={ChevronDown} primaryColor={IconColor.BLUE} />
              </div>
            </div>
            {!(columns.length === columnIdx + 1 && !stateOfColumns[column.name]) && (
              <HorizontalLine className="mobile-only" />
            )}
            <div
              className={`categories-links__column-elements ${
                stateOfColumns[column.name] ? "" : "hide-column-elements"
              }`}
            >
              {column.data.map((elem, elemIdx) => (
                <React.Fragment
                  key={`${column && column.name ? column.name : "column"}-${elem && elem.name ? elem.name : `elem-${elemIdx}`}`}
                >
                  <a
                    onClick={(event) => {
                      if (elem.name === "ustawienia cookie") {
                        event.preventDefault();
                        mbiscuit.open();
                      }
                      if (elem.type === "ruleMAuto") {
                        openRules(event);
                      }
                    }}
                    href={elem.type === "ruleMAuto" || elem.link === "javascript:mbiscuit.open()" ? "#" : elem.link}
                    target={elem.type === "ruleMAuto" ? undefined : elem.target ? elem.target : ""}
                    rel={elem.type === "ruleMAuto" ? undefined : elem.target ? "noreferrer" : ""}
                    className="categories-links__column-element"
                  >
                    <Text as="p" color={FontColor.DARK}>
                      {elem.name}
                    </Text>
                  </a>
                  {!(column.data.length === elemIdx + 1) && <HorizontalLine className="mobile-only" />}
                </React.Fragment>
              ))}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default FooterCategoriesLinks;
